import { TranslationAction } from './types';

/*
 * This diff is merged into the translations and the translation-interface for local development.
 *
 * If you want them to become "productive":
 * - You can update them manually in the POEditor-Interface or via API request (`pnpm pushTranslations`)
 * - You set it back to an empty array if finished successfully
 *
 */
export const diff: TranslationAction[] = [
  {
    newTermWithContext: 'Validation.MinutesOutOfRange',
    translation: 'Minutes must be between 0 and 59.',
  },
  {
    newTermWithContext: 'EvaluationLimitsHint',
    translation:
      'Enter the limits to be applied during the job execution to evaluate the measurement results.',
  },
  {
    newTermWithContext: 'EnumerationEvaluationHint',
    translation: 'Assign an evaluation result to an enumeration item.',
  },
  {
    newTermWithContext: 'InstructionForTaskExecution',
    translation: 'Instruction for task execution',
  },
];
